import * as React from "react";
import ButtonSecondary from "widget/buttonSecondary";
import { connect } from "react-redux";

interface ISecondaryCheckProps {
  // 订单号
  orderNo: any;
  // 二次检查
  secondCheck: any;
  // 刷新订单
  searchOrder: any;
}

// 二次检查
class SecondaryCheck extends React.Component<ISecondaryCheckProps, any> {
  constructor(props: ISecondaryCheckProps) {
    super(props);
  }

  renderText = () => {
    return (
      <div>
        <span>确定为选中的</span>
        <span style={{ color: "red" }}>{this.props.orderNo.length}</span>
        <span>个订单二次检查吗？</span>
      </div>
    );
  };

  render() {
    return (
      <div className="button-group-child">
        <ButtonSecondary
          buttonText="二次检查"
          modalTitle="二次检查"
          ids={this.props.orderNo}
          modalText={this.renderText()}
          warningText="请选择订单"
          successText="二次检查成功"
          submit={this.props.secondCheck}
          cb={this.props.searchOrder}
        />
      </div>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    secondCheck: dispatch.orderInfo.secondCheck
  };
};

export default connect(
  null,
  mapDispatch
)(SecondaryCheck);
